import { Api } from '@/services/Api'

export default {
  getMainBatteryData(plantId) {
    return Api().get(`/api/v2/battery/mainBattery/${plantId}`)
  },
  getEmcData(plantId) {
    return Api().get(`/api/v2/battery/emc/${plantId}`)
  },
  getSubBatteryData(plantId) {
    return Api().get(`/api/v2/battery/subBattery/${plantId}`)
  },
  fetchGraphData(plantId, deviceId) {
    return Api().get(`/api/v2/battery/mainBattery/graph/${plantId}${deviceId ? `?deviceId=${deviceId}` : ''}`)
  },
  fetchFlowDiagramData(payload) {
    return Api().post('/api/v2/battery/flowDiagram', payload)
  }
}
